<div class="service-order-page" *ngIf="orderDetail; else loadingOrError">
  <!-- Main Card Content -->
  <div class="main-card">
    <!-- Order Header -->
    <div class="order-header">
      <div class="header-content">
        <div class="header-left">
          <button mat-icon-button (click)='goBack()' aria-label='Volver' class='back-btn'>
            <mat-icon>arrow_back</mat-icon>
          </button>
          <div class="order-title">
            <p>Orden de Servicio</p>
            <h1>Nro. O/S {{ padNumber(orderDetail.nroOs) }}</h1>
          </div>
        </div>
      </div>
    </div>

    <div class="content-area">
      <!-- === SECCIÓN 1: INFORMACIÓN BÁSICA === -->
      <div class="section-container">
        <div class="section-header">
          <div class="icon-box blue">
            <mat-icon>info</mat-icon>
          </div>
          <h2>Información Básica</h2>
        </div>

        <div class="info-grid">
          <div class="info-card" *ngIf="orderDetail.transportOrderId || orderDetail.nroIE">
            <span class="label">{{ orderDetail.transportOrderId ? 'NRO de O/T' : 'Nro. I/E' }}</span>
            <p class="value">{{ orderDetail.transportOrderId || orderDetail.nroIE || '-' }}</p>
          </div>
          <div class="info-card" *ngIf="!isExtraCostos()">
            <span class="label">Reserva</span>
            <p class="value">{{ orderDetail.reserva || '-' }}</p>
          </div>
          <div class="info-card">
            <span class="label">Ref. Cliente</span>
            <p class="value">{{ orderDetail.refCliente || '-' }}</p>
          </div>
          <div class="info-card">
            <span class="label">Cliente</span>
            <p class="value font-bold">{{ orderDetail.cliente || '-' }}</p>
          </div>
          <div class="info-card">
            <span class="label">Exportador</span>
            <p class="value">{{ orderDetail.exportador || '-' }}</p>
          </div>
          <div class="info-card" *ngIf="!isExtraCostos()">
            <span class="label">Viaje</span>
            <p class="value">{{ orderDetail.viaje || '-' }}</p>
          </div>
        </div>
      </div>

      <!-- === SECCIÓN 2: PUERTOS Y FECHAS === -->
      <div class="ports-section" *ngIf="!isExtraCostos()">
        <div class="section-header">
          <div class="icon-box emerald">
            <mat-icon>place</mat-icon>
          </div>
          <h2>Puertos y Fechas</h2>
        </div>

        <div class="flow-container">
          <!-- POL -->
          <div class="port-item">
            <div class="icon-label">
              <mat-icon class="text-blue">place</mat-icon>
              <span>POL</span>
            </div>
            <p class="port-name">{{ orderDetail.pol || '-' }}</p>
            <p class="terminal-name" *ngIf="orderDetail.terminal">
              Terminal: {{ orderDetail.terminal }}
            </p>
          </div>

          <!-- Arrow -->
          <div class="flow-arrow">
            <mat-icon class="truck-icon">local_shipping</mat-icon>
            <mat-icon class="arrow-icon">arrow_forward</mat-icon>
          </div>

          <!-- POD -->
          <div class="port-item">
            <div class="icon-label">
              <mat-icon class="text-emerald">place</mat-icon>
              <span>POD</span>
            </div>
            <p class="port-name">{{ orderDetail.pod || '-' }}</p>
            <p class="terminal-name">
              ETD: {{ formatDate(orderDetail.etd) }}
            </p>
          </div>
        </div>
      </div>

      <!-- === SECCIÓN 3: INFORMACIÓN DE EMBARQUE === -->
      <div class="section-container" *ngIf="orderDetail.tipoEmbarque || orderDetail.sConv || orderDetail.tratamientoFrio || orderDetail.especie">
        <div class="section-header">
          <div class="icon-box amber">
            <mat-icon>inventory</mat-icon>
          </div>
          <h2>Información de Embarque</h2>
        </div>

        <div class="info-grid">
          <div class="info-card" *ngIf="orderDetail.tipoEmbarque">
            <span class="label">Tipo Embarque</span>
            <p class="value with-icon">
              <mat-icon [class.text-amber]="orderDetail.tipoEmbarque === 'Pallet'" [class.text-blue]="orderDetail.tipoEmbarque === 'Contenedor'">
                {{ orderDetail.tipoEmbarque === 'Pallet' ? 'inventory_2' : 'directions_boat' }}
              </mat-icon>
              {{ orderDetail.tipoEmbarque }}
            </p>
          </div>
          <div class="info-card" *ngIf="orderDetail.sConv">
            <span class="label">SHIP CONVENIENCE</span>
            <p class="value">{{ orderDetail.sConv }}</p>
          </div>
          <div class="info-card" *ngIf="orderDetail.tratamientoFrio">
            <span class="label">Tratamiento Frío</span>
            <p class="value">{{ orderDetail.tratamientoFrio }}</p>
          </div>
          <div class="info-card" *ngIf="orderDetail.especie">
            <span class="label">Especie</span>
            <p class="value">{{ orderDetail.especie }}</p>
          </div>
        </div>
      </div>

      <!-- === SECCIÓN 4: CONTENEDORES === -->
      <div class="section-container" *ngIf="orderDetail.contenedores && orderDetail.contenedores.length > 0">
        <div class="section-header">
          <div class="icon-box blue">
            <mat-icon>directions_boat</mat-icon>
          </div>
          <h2>Contenedores</h2>
          <span class="count-badge blue">{{ orderDetail.contenedores.length }}</span>
        </div>

        <div class="table-wrapper">
          <table>
            <thead>
              <tr>
                <th class="sticky-col">#</th>
                <th>Nro. Contenedor</th>
              </tr>
            </thead>
            <tbody>
              <tr *ngFor="let contenedor of orderDetail.contenedores; let i = index">
                <td class="sticky-col font-bold">{{ i + 1 }}</td>
                <td class="font-mono font-bold">{{ contenedor }}</td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>

      <!-- === SECCIÓN 5: INFORMACIÓN DEL SERVICIO === -->
      <div class="section-container">
        <div class="section-header">
          <div class="icon-box indigo">
            <mat-icon>description</mat-icon>
          </div>
          <h2>Información del Servicio</h2>
        </div>

        <div class="info-grid">
          <div class="info-card">
            <span class="label">Servicio</span>
            <p class="value font-bold">{{ orderDetail.servicio || '-' }}</p>
          </div>
          <div class="info-card" *ngIf="orderDetail.pagoPorCuentaDe">
            <span class="label">Pago por Cuenta de</span>
            <p class="value">{{ orderDetail.pagoPorCuentaDe }}</p>
          </div>
          <div class="info-card">
            <span class="label">Tipo Facturación</span>
            <p class="value">
              <span [class.text-blue]="orderDetail.tipoFacturacion === 'Venta'" 
                    [class.text-emerald]="orderDetail.tipoFacturacion === 'Traspaso'">
                {{ orderDetail.tipoFacturacion || '-' }}
              </span>
            </p>
          </div>
          <div class="info-card" *ngIf="orderDetail.nroLiquidacion">
            <span class="label">Nro. Liquidación</span>
            <p class="value font-mono">{{ orderDetail.nroLiquidacion }}</p>
          </div>
        </div>
      </div>

      <!-- === SECCIÓN 6: INFORMACIÓN FINANCIERA === -->
      <div class="financial-section">
        <div class="section-header" style="margin-top: 0; margin-bottom: 1rem;">
          <div class="icon-box emerald">
            <mat-icon>monetization_on</mat-icon>
          </div>
          <h2>Información Financiera</h2>
        </div>

        <div class="financial-grid">
          <div class="info-card">
            <span class="label">Cantidad</span>
            <p class="value font-mono">{{ orderDetail.cantidad || 0 }}</p>
          </div>
          <div class="info-card">
            <span class="label">Precio Unitario</span>
            <p class="value font-mono">{{ formatCurrency(orderDetail.precioUnitario) }}</p>
          </div>
          <div class="info-card">
            <span class="label">Precio Neto</span>
            <p class="value font-mono">{{ formatCurrency(orderDetail.precioNeto) }}</p>
          </div>
          <div class="info-card">
            <span class="label">IVA</span>
            <p class="value font-mono">{{ formatCurrency(orderDetail.ivaPrecio) }}</p>
          </div>
          <div class="info-card">
            <span class="label">Gestión Neto</span>
            <p class="value font-mono">{{ formatCurrency(orderDetail.gestionNeto) }}</p>
          </div>
          <div class="info-card">
            <span class="label">Moneda</span>
            <p class="value font-mono font-bold">{{ orderDetail.moneda || 'CLP' }}</p>
          </div>
          <div class="info-card highlight">
            <span class="label">Total a Pagar</span>
            <p class="value font-mono font-bold text-emerald large">
              {{ formatCurrency(orderDetail.precioAPagar) }}
            </p>
          </div>
        </div>
      </div>

      <!-- === SECCIÓN 7: PROVEEDOR === -->
      <div class="section-container" *ngIf="orderDetail.proveedor">
        <div class="section-header">
          <div class="icon-box purple">
            <mat-icon>business</mat-icon>
          </div>
          <h2>Proveedor</h2>
        </div>

        <div class="info-grid">
          <div class="info-card" *ngIf="orderDetail.proveedor.name">
            <span class="label">Nombre</span>
            <p class="value font-bold">{{ orderDetail.proveedor.name }}</p>
          </div>
          <div class="info-card" *ngIf="orderDetail.proveedor.rut">
            <span class="label">RUT</span>
            <p class="value font-mono">{{ orderDetail.proveedor.rut }}</p>
          </div>
          <div class="info-card" *ngIf="orderDetail.proveedor.fullName">
            <span class="label">Razón Social</span>
            <p class="value">{{ orderDetail.proveedor.fullName }}</p>
          </div>
          <div class="info-card" *ngIf="orderDetail.proveedor.bankDetails">
            <span class="label">Datos Bancarios</span>
            <p class="value font-mono">{{ orderDetail.proveedor.bankDetails }}</p>
          </div>
          <div class="info-card" *ngIf="orderDetail.proveedor.invoiceNumber">
            <span class="label">Nro. Factura</span>
            <p class="value font-mono">{{ orderDetail.proveedor.invoiceNumber }}</p>
          </div>
          <div class="info-card" *ngIf="orderDetail.proveedor.documentType">
            <span class="label">Tipo Documento</span>
            <p class="value">{{ orderDetail.proveedor.documentType }}</p>
          </div>
          <div class="info-card" *ngIf="orderDetail.proveedor.documentNumber">
            <span class="label">Nro. Documento</span>
            <p class="value font-mono">{{ orderDetail.proveedor.documentNumber }}</p>
          </div>
        </div>
      </div>

      <!-- === SECCIÓN 8: COMENTARIOS === -->
      <div class="section-container" *ngIf="orderDetail.comentariosCliente">
        <div class="section-header">
          <div class="icon-box indigo">
            <mat-icon>comment</mat-icon>
          </div>
          <h2>Comentarios del Cliente</h2>
        </div>

        <div class="comments-content">
          <p>{{ orderDetail.comentariosCliente }}</p>
        </div>
      </div>

    </div> <!-- End Content Area -->
  </div> <!-- End Main Card -->
</div> <!-- End Service Order Page -->

<ng-template #loadingOrError>
  <div *ngIf="loading" class="loading-container">
    <mat-spinner diameter="50"></mat-spinner>
    <p>Cargando detalle de la orden de servicio...</p>
  </div>
  <div *ngIf="error" class="error-container">
    <mat-icon color="warn">error</mat-icon>
    <p>{{ error }}</p>
    <button mat-raised-button color="primary" (click)="goBack()">
      <mat-icon>arrow_back</mat-icon>
      Volver
    </button>
  </div>
</ng-template>
